export default __webpack_public_path__ + "static/media/gallery_00.a315b6bf.jpg";